import React from "react";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { PurchaseOrder } from "features/PurchaseOrders/types/purchase-order.types";

interface ConfirmModalProps {
  show?: boolean;
  onConfirmClick?: () => void;
  onCloseClick?: () => void;
  record?: PurchaseOrder | null;
}

const ConfirmModal = ({
  show,
  onConfirmClick,
  onCloseClick,
  record,
}: ConfirmModalProps) => {
  return (
    <React.Fragment>
      <Modal fade={true} isOpen={show} toggle={onCloseClick} centered>
        <ModalHeader className="modal-title">#{record?.code}</ModalHeader>
        <ModalBody className="text-center p-5">
          <i className="bx bxs-badge-check display-4 text-success"></i>
          <div className="mt-4">
            <h4 className="mb-3">Confirm purchase order</h4>
            <p className="text-muted mb-4">
              Confirming this purchase order will mark any linked material
              requests as <strong>Completed</strong> and allow stock to be
              received against it via goods receipts (GRN). Draft lines can no
              longer be edited after confirmation.
            </p>
            <div className="hstack gap-2 justify-content-center">
              <Button color="light" onClick={onCloseClick}>
                Back
              </Button>
              <Button color="success" type="button" onClick={onConfirmClick}>
                Confirm
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default ConfirmModal;
